export default {"src":"/_next/static/media/newanimation.b1db196c.gif","height":47,"width":47,"blurWidth":0,"blurHeight":0};